import { combineReducers } from 'redux'
import coreReducer from 'components/core/state/reducer'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const persistReducerConfig = (key: string) => ({
  key,
  storage,
})

export default combineReducers({
  core: persistReducer(persistReducerConfig('core'), coreReducer),
})
